
/**
 * The angularjs states related to the module in-message
 */
inMessageStates.$inject = ['$stateProvider'];
export function inMessageStates($stateProvider) {
    $stateProvider
        .state('auth.alcmeon.fuse.inmessage-chat', {
            url: '/inmessage-chat/:pageId?version&extras',
            views: {
                'container@auth': {
                    template: '<angular-in-message></angular-in-message>'
                }
            }
        })
}